define([
    'angular',
    'underscore',

], (angular, _) => {

    MFPService.$inject = ['qnb.CustomQuoteService', 'DefaultErrorHandlerService', 'MFPCoverageService', 'ModalService', 'TextRetrievalService', 'ContextService', 'configBasler', 'LocaleService', 'StateUtils', 'ViewModelService', 'LoggingService', 'BaslerLoggingConstants'];

    function MFPService(CustomQuoteService, DefaultErrorHandlerService, MFPCoverageService, ModalService, TextRetrievalService, ContextService, ConfigBasler, LocaleService, StateUtils, ViewModelService, LoggingService, BaslerLoggingConstants) {
        return {
            hasAtLeastOneDeliveryVan: hasAtLeastOneDeliveryVan,
            shouldDisplayCoverageTerm: shouldDisplayCoverageTerm,
            formatCoverageTerm: formatCoverageTerm,
            initProofOfInsuranceQuestions: initProofOfInsuranceQuestions,
            initMatriculationInformation: initMatriculationInformation,
            accountHolderIsMainDriver: accountHolderIsMainDriver,
            hasVariousDrivers: hasVariousDrivers,
            setSelectedQuote: setSelectedQuote,
            updateOffering: updateOffering,
            hasWechselschild: hasWechselschild,
            reset: reset,
            toggleCoverage: toggleCoverage,
            showUWPopupIfNeeded: showUWPopupIfNeeded,
            getContractConditionsDocURL: getContractConditionsDocURL,
            getContractConditionsLichtensteinDocURL: getContractConditionsLichtensteinDocURL,
            getVehicle: getVehicle,
            autoCapitalize: autoCapitalize,
            showParkingOverNight: showParkingOverNight,
            showFreeGarageSelection: showFreeGarageSelection,
            getTermsWhichIncludeTerm: getTermsWhichIncludeTerm,
        };

        /**
         * Removes customizations and sets default values according Package & Offering
         * This operation goes to the backend
         * @param quotedSubmission submission to reset
         * @param selectedOffer the selected offer
         * @returns the reseted quote
         */
        function reset(quotedSubmission, selectedOffer) {

            const operation = CustomQuoteService.resetCustomQuote('inpage_quoteandbind', selectedOffer, quotedSubmission.sessionUUID, quotedSubmission.quoteID);
            operation.then((updatedOffer) => {
                updateOffering(selectedOffer, updatedOffer);
            }, (error) => {
                DefaultErrorHandlerService.getErrorHandlerForError(error)();
            });

            return operation;
        }

        /**
         * Suppresses a coverage on a custom submission:
         *   - updates the coverages
         *   - re-quotes
         * This operation goes to the backend
         * @param quotedSubmission submission to toggle a coverage on
         * @param offering  an offering model
         * @param coverageCode  coverage code for coverage you want to toggle
         * @param coverageGroup coverage group (as often used in MFPCoverageService)
         * @returns {*} A promise that contains an updated version of the offer
         */
        function toggleCoverage(quotedSubmission, offering, coverageCode, coverageGroup) {
            const offeringCopy = angular.copy(offering);
            const coverage = MFPCoverageService.getCoverageFromMfpLineByCodeAndGroup(offeringCopy.lobs.mFPLine, coverageCode, coverageGroup);
            coverage.selected = !coverage.selected;
            coverage.updated = true;

            return CustomQuoteService.updateCustomQuote('quoteandbind', offeringCopy, quotedSubmission.sessionUUID, quotedSubmission.quoteID);
        }


        /*
         * Function to display UWIssues that shall not redirect to contact us page.
         * Still in progress, as it shall retrieve descriptions from Magnolia
         * 
         * @param submissionViewModel submissionVM of the controller
         * @param uwPromise promise showing the popup with messages. Undefined if there's no popup
         */
        function showUWPopupIfNeeded(submissionViewModel) {
            //Controller is not restarted or initialized again if flow returns to it again (from risk-data to risk-data)
            //However, submissionViewModel() will return new ModelData
            if (submissionViewModel.uWIssues.value) {
                const uwIssueNr = submissionViewModel.uWIssues.value[0].code;

                //remove UW issues after popup in order to not show that popup again
                submissionViewModel.uWIssues.value = undefined;
                if (StateUtils.activeDataForState(true).flowModel.snapshot) {
                    StateUtils.activeDataForState(true).flowModel.snapshot.uWIssues.value = undefined;
                }

                //retrieve text and display it
                TextRetrievalService.getUWIssueText(uwIssueNr)
                    .then(uwIssueDescription => {
                        LoggingService.logInfo(BaslerLoggingConstants.TOASTERROR, new Error(uwIssueDescription));
                        return ModalService.showError(undefined, uwIssueDescription);
                    });
            }

        }

        /**
         * Returns vehicle with the given vehicleNumber of the given vehicles array
         * @param vehicles  vehicle array of the submission (quoteandbind.submission.draftData.lobs.mFPLine.vehicles)
         * @param vehicleNumber  the vehicleNumber of the vehicle which you wanna get
         * @returns the requested vehicle object
         */
        function getVehicle(vehicles, vehicleNumber) {
            return vehicles.children.find(vehicle => vehicle.value.vehicleNumber === vehicleNumber);
        }

        function getContractConditionsDocURL() {
            let productPrefix = 'baloisedirect';
            if (ContextService.isTCSProduct()) {
                productPrefix = 'tcs';
            }
            const magnoliaAssetsUrl = ConfigBasler.magnoliaAssets.url;
            switch (LocaleService.getCurrentLocale()) {
                case 'fr':
                    return `${magnoliaAssetsUrl + productPrefix}-Assurance-vehicules-a-moteur-Conditions-contractuelles.pdf`;
                case 'it':
                    return `${magnoliaAssetsUrl + productPrefix}-Assicurazione-veicoli-a-motore-Condizioni-contrattuali.pdf`;
                case 'en_US':
                    return `${magnoliaAssetsUrl + productPrefix}-Motor-vehicle-insurance-Terms-and-conditions.pdf`;
                default:
                    return `${magnoliaAssetsUrl + productPrefix}-Motorfahrzeugversicherung-Vertragsbedingungen.pdf`;
            }
        }

        function getContractConditionsLichtensteinDocURL() {
            let productPrefix = 'baloisedirect';
            if (ContextService.isTCSProduct()) {
                productPrefix = 'tcs';
            }
            const magnoliaAssetsUrl = ConfigBasler.magnoliaAssets.url;
            switch (LocaleService.getCurrentLocale()) {
                case 'fr':
                    return `${magnoliaAssetsUrl + productPrefix}-Dispositions-supplementaires-liechtensteinois.pdf`;
                case 'it':
                    return `${magnoliaAssetsUrl + productPrefix}-Disposizioni-supplementari-Liechtenstein.pdf`;
                case 'en_US':
                    return `${magnoliaAssetsUrl + productPrefix}-Additional-terms-Lichtenstein.pdf`;
                default:
                    return `${magnoliaAssetsUrl + productPrefix}-Bestimmungen-Lichtenstein.pdf`;
            }
        }


        /**
         *
         * @param licensePlateNumber
         * @returns empty object (representing ProofOfInsuranceQuestionsDTO) in case licensePlate present. Requiredness of fields will be driven by backend
         */
        function initProofOfInsuranceQuestions(licensePlateNumber) {
            return _.isEmpty(licensePlateNumber) ? null : ViewModelService.create({
                licensePlateCurrentlyRegistered: undefined,
                mainVehicleRegisteredToLicensePlate: undefined,
                additionalVehicleRegisteredToLicensePlate: undefined,
                licensePlateRegisteredToHolder: undefined,
                isMultivehicle: undefined,
            }, 'pc', 'ch.baloise.gw.pc.edge.capabilities.quote.binding.dto.BaslerProofOfInsuranceDTO').value;
        }

        /**
         *

         * @returns empty object (representing MFPMatriculationInformation_ExtDTO). Requiredness of fields will be driven by backend
         */
        function initMatriculationInformation() {
            return ViewModelService.create({matriculationNumber: undefined}, 'pc', 'ch.baloise.gw.pc.edge.capabilities.quote.lob.mfp.draft.dto.MFPMatriculationInformation_ExtDTO').value;
        }

        /**
         *
         * @param vehicle which will be tested against the correct vehicleType


         * @returns boolean which indicates if ParkingOverNight should be shown or not
         */
        function showParkingOverNight(vehicle) {
            return vehicle && vehicle.vehicleType.value === 'PersonalAuto' && !ContextService.isPartnerProduct();
        }

        function flatMapArray(arr) {
            return arr.reduce((acc, x) => acc.concat(x), [])
        }


        /**
         *
         * @param offering which should have terms which include the termName
         * @param termName which should be checked for


         * @returns CovPartCovTerms all terms of a CovPartCoverage, if the CovPartCoverageTerms include a term with the termName
         */
        function getTermsWhichIncludeTerm(offering, termName) {
            return flatMapArray(offering.lobs.mFPLine.vehicleCoverages.map(vc => vc.coverages.reduce((acc, curr) => {
                if (curr.terms.some(t => t.patternCode === termName) ) {
                    acc = curr.terms;
                }
                return acc;
            }, [])));
        }

        /**
         *
         * @param offering which should be checked if term "MFPPartialComprehensiveFreeGarageChoice" exists


         * @returns boolean which indicates if MFPPartialComprehensiveFreeGarageChoice term exists
         */
        function doesFreeGarageTermExist(offering) {
            return getTermsWhichIncludeTerm(offering, "MFPPartialComprehensiveFreeGarageChoice").length > 0
        }

        /**
         *
         * @param offering which should be checked


         * @returns boolean which indicates if the free garage selection should be shown
         */
        function showFreeGarageSelection(offering) {
            return (ContextService.isDirectProduct() || ContextService.isTCSProduct()) && doesFreeGarageTermExist(offering);
        }
    }

    return MFPService;

    // file local functions

    function hasAtLeastOneDeliveryVan(mainVehicleView, additionalVehicleView) {
        const v1Category = mainVehicleView ? mainVehicleView.value.getVehicleCategory() : '';
        const v2Category = additionalVehicleView ? additionalVehicleView.value.getVehicleCategory() : '';

        return v1Category === 'DeliveryVan' || v2Category === 'DeliveryVan';
    }


    function shouldDisplayCoverageTerm(term) {
        return term.isVisibleInOverview;
    }

    function formatCoverageTerm(term, separator) {
        const sep = separator || ': ';

        if (term.termTypeCode === 'BooleanCovTermInternal') {
            return term.name;
        }

        const displayName = term.name;
        const displayValue = formatMillions(term.chosenTermValue);
        return displayName + sep + displayValue;
    }

    /**
     * Formats values like "100'000'000" as "100 mio." by replacing "'000'000" at the end of the string with " mio.".
     * @param value
     */
    function formatMillions(value) {
        return value.replace(/'000'000$/, ' mio.');
    }

    function hasWechselschild(mfpLine) {
        return mfpLine.vehicleCoverages && mfpLine.vehicleCoverages.length > 1;
    }

    function accountHolderIsMainDriver(draftData) {
        if (!draftData.lobs.mFPLine.hasDrivers()) {
            return false;
        }
        const driverPerson = draftData.lobs.mFPLine.drivers[0].person;
        const accountHolderContact = draftData.accountHolder.contact;
        return Boolean(accountHolderContact && driverPerson && accountHolderContact.publicID === driverPerson.publicID);
    }

    function hasVariousDrivers(draftData) {
        return draftData.lobs.mFPLine.hasVehicles() &&
            draftData.lobs.mFPLine.vehicles[0].hasVariousDrivers;
    }

    function setSelectedQuote(submission, quote) {
        if (!submission) {
            throw new ReferenceError('given submission is not defined');
        }
        if (!quote) {
            throw new ReferenceError('given quote is not defined');
        }
        if (!submission.bindData) {
            submission.bindData = {};
        }
        submission.bindData.chosenQuote = quote.publicID;

        if (submission.draftData && submission.draftData.policyAddress) {
            if (!submission.bindData.billingAddress) {
                submission.bindData.billingAddress = {};
            }
            angular.copy(submission.draftData.policyAddress, submission.bindData.billingAddress);
        }
    }

    function updateOffering(target, source) {
        target.lobs = source.lobs;
        target.total = source.total;
        target.originalTotal = source.originalTotal;
        target.monthlyPremium = source.monthlyPremium;
        target.totalBeforeTaxes = source.totalBeforeTaxes;
        target.taxes = source.taxes;
        target.isCustomized = source.isCustomized;
    }

    function autoCapitalize(value) {
        //Names with apostrophes or spaces are omitted
        if (value.includes(' ') || value.includes('\'')) {
            return value;
        }

        return value.replace(/\b([^-]+)\b/g, (txt) => {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/services/MFPService.js